<template>
<div class="terms-wrapper" data-aos="fade-left">
    <h1 class='terms-title'>IMPRESSUM</h1>

    <div class="term">
        <h3 class='terms-subtitle'><i>CleanData </i></h3>
        <h3 class='terms-subtitle'><i>Rechtsträger:  </i></h3>
        <h3 class='terms-subtitle'><i>LEVELS AG   </i></h3>
        <h3 class='terms-subtitle'><i>St. Galler Str. 5</i></h3>
        <h3 class='terms-subtitle'><i>9042 Speicher  </i></h3> 
    </div>
 
    <div class="term">
        <h3 class='terms-subtitle'>Kontakt</h3>
        <p class='terms-sm-text '>Telefon: +41 (0)71 544 51 55</p>
        <p class='terms-sm-text '>E-Mail: info@cleandata.ch</p>
        <p class='terms-sm-text '>Web: www.cleandata.ch</p>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>Vertreten durch:</h3>
        <p class='terms-sm-text '>Yeshe Sherpa, Verwaltungsratspräsident</p>
        <p class='terms-sm-text '>Kristian Krasniqi, Mitglied des Verwaltungsrats</p>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>Eingetragen im Handelsregister des Kanton Appenzell A.Rh. </h3>
        <p class='terms-sm-text '>UID: CHE-406.509.215</p>
    </div>  
</div>
</template> 

<script>
export default {

}
</script>

<style lang="scss" scoped>
.terms-wrapper {
    padding: 20px 0;
    width: 80%;
    margin: 0 auto;
}

.terms-title {
    margin: 0;
    margin-bottom: 40px;
    font-size: 50px;
    font-weight: bold;
    color: #000000;
}

.terms-subtitle {
    font-size: 20px;
    color: #000000;
    margin-bottom: 10px;
}

.terms-sm-text {
    font-size: 18px;
    margin-bottom: 10px;
    color: #666666;
}

.black {
    color: #000000;
}

.highlight-text {
    color: #FF3A67;
}
 

.term {
    margin-bottom: 40px;

    &:last-child {
        margin: 0;
    }
}

a {
    color: #666666;
    text-decoration: underline;
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {}

/* 2470 - 1328 */
@media (min-width: 2470px) {
    .terms-wrapper {
        padding: 30px 0;
        width: 80%;
    }

    .terms-title {
        margin-bottom: 50px;
        font-size: 54px;
    }

    .terms-subtitle {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .terms-sm-text {
        font-size: 22px;
        margin-bottom: 20px;
    } 

    .term {
        margin-bottom: 50px;

        &:last-child {
            margin: 0;
        }
    }
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .terms-title {
        font-size: 56px;
    }

    .terms-subtitle {
        font-size: 26px;
    }

    .terms-sm-text {
        font-size: 24px;
    }
 
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {}

/* 3000-1870 */
@media(min-width: 3000px) {
    .terms-title {
        font-size: 58px;
    }

    .terms-subtitle {
        font-size: 28px;
    }

    .terms-sm-text {
        font-size: 26px;
    } 
}

/*3200-1800*/
@media(min-width: 3200px) {}

/*3360-1890 1695*/
@media(min-width:3360px) {
    .terms-title {
        font-size: 60px;
    }

    .terms-subtitle {
        font-size: 30px;
    }

    .terms-sm-text {
        font-size: 28px;
    } 
}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .terms-title {
        font-size: 64px;
    }

    .terms-subtitle {
        font-size: 34px;
    }

    .terms-sm-text {
        font-size: 32px;
    } 
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .terms-wrapper { 
        width: 85%;
    } 
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) { 
    .terms-title { 
        font-size: 48px;
    }

    .terms-subtitle {
        font-size: 18px; 
    }

    .terms-sm-text {
        font-size: 16px; 
    }  
}

/* 1600 - 757 */
@media (max-width: 1600px) {}

/*1536-864*/
@media(max-width:1536px) {}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {}

/*1366-638*/
@media (max-width:1366px) {
    .terms-wrapper { 
        width: 90%;
    } 

    .terms-title { 
        font-size: 46px; 
        margin-bottom: 35px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {}

/* 1200-1920 */
@media (max-width:1200px) {}

/*1134x712*/
@media(max-width:1134px) {}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    .terms-wrapper { 
        width: 95%;
    } 

    .terms-title { 
        font-size: 44px;  
    }
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {
    .terms-title { 
        font-size: 42px;  
    }
}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .terms-title { 
        font-size: 40px;  
    }

    .terms-subtitle {
        font-size: 16px;
        margin-bottom: 5px;
    }

    .terms-sm-text {
        font-size: 14px;
        margin-bottom: 5px;
    } 

    .term {
        margin-bottom: 30px;
    }
}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {
    .terms-title { 
        font-size: 38px;  
        text-align: center;
    }
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {
    .terms-title { 
        font-size: 36px;   
    }
}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {
    .terms-wrapper {
        padding: 10px 0;
    }

    .terms-title { 
        font-size: 34px;   
    }
}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .terms-title { 
        font-size: 32px;   
    }
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .terms-title { 
        font-size: 30px;
        margin-bottom: 30px;   
    }

    .terms-subtitle {
        font-size: 14px;
    }

    .terms-sm-text {
        font-size: 12px;
    } 
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {
    .terms-title { 
        font-size: 28px;    
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}
</style>
